// Password change modal — ports profile.js _changePassword.
import { useState } from 'react'
import type { FormEvent } from 'react'
import { profileApi } from '../../api/profile'
import { messageFromError, ApiError } from '../../api/client'
import { toast } from '../../store/toastStore'
import styles from './Settings.module.css'

export default function PasswordModal({ onClose }: { onClose: () => void }) {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [saving, setSaving] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    if (!current || !next || !confirm) return toast('Заполните все поля', 'error')
    if (next.length < 8) return toast('Пароль минимум 8 символов', 'error')
    if (next !== confirm) return toast('Пароли не совпадают', 'error')
    setSaving(true)
    try {
      await profileApi.changePassword(current, next)
      toast('Пароль успешно изменён', 'success')
      onClose()
    } catch (err) {
      // Wrong current password comes back as 401 (backend detail is English);
      // show a localized inline error and stay on the modal (no logout).
      const msg =
        err instanceof ApiError && err.status === 401
          ? 'Неверный текущий пароль'
          : messageFromError(err, 'Ошибка смены пароля')
      toast(msg, 'error')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Сменить пароль</h3>
          <button className={styles.modalClose} onClick={onClose}>✕</button>
        </div>
        <form className={styles.form} onSubmit={submit}>
          <input className={styles.input} type="password" placeholder="Текущий пароль" value={current} onChange={(e) => setCurrent(e.target.value)} />
          <input className={styles.input} type="password" placeholder="Новый пароль (мин. 8)" value={next} onChange={(e) => setNext(e.target.value)} />
          <input className={styles.input} type="password" placeholder="Подтвердите пароль" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          <button className={styles.primaryBtn} type="submit" disabled={saving}>
            {saving ? 'Сохранение...' : 'Сменить пароль'}
          </button>
        </form>
      </div>
    </div>
  )
}
